
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M12 21C14.2091 21 16 19.2091 16 17C16 14.7909 14.2091 13 12 13C9.79086 13 8 14.7909 8 17C8 19.2091 9.79086 21 12 21Z' fill='#323232'/><path d='M11.9999 3C8.48988 3 5.27988 4.29 2.79988 6.41C2.35988 6.79 2.31988 7.47 2.73988 7.89L6.33988 11.49C6.69988 11.85 7.25988 11.88 7.65988 11.57C8.85988 10.63 10.3699 10.07 11.9999 10.07C13.6399 10.07 15.1399 10.63 16.3399 11.56C16.7399 11.87 17.2999 11.84 17.6499 11.48L21.2499 7.88C21.6699 7.46 21.6299 6.78 21.1799 6.4C18.7199 4.28 15.5099 3 11.9999 3Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-compass-calibration`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconCompassCalibration

    ```js
    <b-new-b-icon-compass-calibration />
    ```
</docs>


